import { render, staticRenderFns } from "./Studies.vue?vue&type=template&id=b1ba2a2a"
import script from "./Studies.vue?vue&type=script&lang=js"
export * from "./Studies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports